import type * as React from 'react';

import { useMediaListener, BREAKPOINTS } from '@xing-com/util';

import { MainPageContext } from './main-page-context';

export const MainPageContextWrapper: React.FC<
  React.PropsWithChildren<unknown>
> = ({ children }) => {
  const breakpoint = useMediaListener();
  const isHandheld = breakpoint === BREAKPOINTS.handheld;

  return (
    <MainPageContext.Provider value={{ isHandheld }}>
      {children}
    </MainPageContext.Provider>
  );
};
